import { NOTE_MAX_LENGTH } from "Components/Analyses/constants";
import type { ResourceDictionary } from "Infrastructure/Translations/ResourceDictionary";
import { Resources } from "Infrastructure/Translations/Resources";
import type { ObjPathProxy } from "ts-object-path";
import { type ObjectSchema, object, string } from "yup";
import { number } from "../Utils/schemaUtils";

export type LiabilityFormType = {
  readonly liabilityType: string;
  readonly name: string;
  readonly value: number;
  readonly clientId?: string | null;
  readonly institution?: string;
  readonly expenseItemId?: string | null;
  readonly note?: string;
  readonly dueDate?: string | null;
};

export const getLiabilityFormSchema: (
  t: (resourcePath: ObjPathProxy<ResourceDictionary, string>, options?: any) => string,
) => ObjectSchema<LiabilityFormType> = (t) => {
  return object({
    liabilityType: string().required(t(Resources.Validation.Required)),
    name: string().required(t(Resources.Validation.Required)),
    value: number().required(t(Resources.Validation.Required)),
    institution: string(),
    expenseItemId: string().nullable(),
    clientId: string().nullable(),
    note: string().max(NOTE_MAX_LENGTH, t(Resources.Validation.String.Max, { count: NOTE_MAX_LENGTH })),
    dueDate: string().nullable(),
  }).defined();
};
